/* AI Path Quiz — Peeshee
   9 questions -> instant personalized AI-path analysis.
   Fully client-side: scoring + pre-written content bank. No LLM, no cost. */
(function () {
  'use strict';

  var STORAGE_KEY = 'peeshee-ai-path-v3';

  /* ---------------- questions ----------------
     w = archetype weights {C creator, B builder, O operator, P professional} */
  var QUESTIONS = [
    {
      id: 'money',
      title: 'What role does money play in this journey?',
      options: [
        { id: 'asap',   label: 'I need income as soon as possible', w: { C: 2, B: 0, O: 0, P: 0 } },
        { id: 'second', label: "I'm building a second income next to my job", w: { C: 1, B: 1, O: 0, P: 1 } },
        { id: 'growth', label: 'Money matters, but growth comes first', w: { C: 0, B: 1, O: 1, P: 1 } },
        { id: 'not',    label: "It's not about money — I want the skills", w: { C: 0, B: 0, O: 2, P: 0 } }
      ]
    },
    {
      id: 'flow',
      title: 'When do you lose track of time?',
      options: [
        { id: 'build',   label: 'Building or fixing a system until it finally works', w: { C: 0, B: 2, O: 1, P: 0 } },
        { id: 'create',  label: 'Creating something — visuals, video, writing, design', w: { C: 2, B: 0, O: 0, P: 1 } },
        { id: 'teach',   label: 'Explaining something and watching someone get it', w: { C: 2, B: 0, O: 0, P: 1 } },
        { id: 'solve',   label: 'Solving a hard problem nobody else figured out', w: { C: 0, B: 1, O: 2, P: 0 } },
        { id: 'optimize',label: 'Organizing chaos into a clean, working process', w: { C: 0, B: 1, O: 1, P: 1 } }
      ]
    },
    {
      id: 'pull',
      title: 'Which part of AI pulls you in the most?',
      textarea: { label: 'Picture your ideal day with AI, one year from now. (optional)', placeholder: 'e.g. I wake up, my agent has already answered client emails, and I spend the morning on renders…' },
      options: [
        { id: 'content', label: 'Making content — images, video, stories', w: { C: 4, B: 0, O: 0, P: 0 } },
        { id: 'agents',  label: 'Agents that do real work for me', w: { C: 0, B: 4, O: 1, P: 0 } },
        { id: 'faster',  label: 'Using AI to do everything 10× faster', w: { C: 0, B: 1, O: 4, P: 0 } },
        { id: 'field',   label: 'Getting ahead of everyone in my own field', w: { C: 0, B: 0, O: 0, P: 4 } },
        { id: 'unsure',  label: "Honestly? I'm not sure yet — that's why I'm here", w: { C: 1, B: 0, O: 0, P: 0 } }
      ]
    },
    {
      id: 'struggle',
      title: "What's the biggest thing you're struggling with?",
      options: [
        { id: 'start',     label: 'I have no idea where to start', w: { C: 0, B: 0, O: 0, P: 0 } },
        { id: 'directions',label: 'Too many directions, I can’t commit to one', w: { C: 0, B: 0, O: 0, P: 0 } },
        { id: 'finish',    label: 'I start things but don’t stick with them', w: { C: 0, B: 0, O: 0, P: 0 } },
        { id: 'technical', label: 'I’m afraid it’s too technical for me', w: { C: 1, B: 0, O: 0, P: 0 } },
        { id: 'time',      label: 'I don’t have enough time', w: { C: 0, B: 0, O: 1, P: 1 } }
      ]
    },
    {
      id: 'spark',
      title: 'When you start something new, what actually happens?',
      options: [
        { id: 'allin',  label: 'I go all-in for days… then suddenly lose interest', w: {} },
        { id: 'plan',   label: 'I research and plan a lot before I dare to start', w: {} },
        { id: 'quick',  label: 'I need quick results or I drop it', w: {} },
        { id: 'steady', label: 'I move slowly, but I rarely quit', w: {} },
        { id: 'paral',  label: 'I get overwhelmed and often don’t start at all', w: {} }
      ]
    },
    {
      id: 'graveyard',
      title: 'Be honest — where do your projects usually die?',
      options: [
        { id: 'day3',    label: 'Day 3, when the novelty wears off', w: {} },
        { id: 'middle',  label: 'The boring middle part', w: {} },
        { id: 'perfect', label: 'Polishing forever, never actually shipping', w: {} },
        { id: 'shiny',   label: 'A newer, shinier idea steals me away', w: {} },
        { id: 'rarely',  label: 'They don’t really die — they just move slowly', w: {} }
      ]
    },
    {
      id: 'value',
      title: 'Which value feels most essential to you?',
      options: [
        { id: 'freedom',   label: 'Freedom & autonomy', w: { C: 1, B: 1, O: 0, P: 0 } },
        { id: 'growth',    label: 'Growth & mastery', w: { C: 0, B: 0, O: 2, P: 0 } },
        { id: 'stability', label: 'Stability & security', w: { C: 0, B: 0, O: 0, P: 2 } },
        { id: 'impact',    label: 'Impact & recognition', w: { C: 2, B: 0, O: 0, P: 1 } }
      ]
    },
    {
      id: 'field',
      title: "What's your field or background?",
      options: [
        { id: 'design', label: 'Architecture, interior or design', w: { C: 1, B: 0, O: 0, P: 2 } },
        { id: 'tech',   label: 'Tech, engineering or data', w: { C: 0, B: 1, O: 2, P: 0 } },
        { id: 'biz',    label: 'Marketing, business or sales', w: { C: 1, B: 1, O: 0, P: 1 } },
        { id: 'none',   label: 'Student / no field yet', w: { C: 1, B: 0, O: 0, P: 0 } },
        { id: 'other',  label: 'Something else', w: { C: 0, B: 0, O: 0, P: 0 } }
      ]
    },
    {
      id: 'exp',
      title: 'How much have you actually used AI?',
      options: [
        { id: 'zero',    label: 'Almost zero', w: { C: 0, B: 0, O: 0, P: 0 } },
        { id: 'casual',  label: 'I chat with ChatGPT sometimes', w: { C: 0, B: 0, O: 0, P: 0 } },
        { id: 'weekly',  label: 'I use AI tools every week', w: { C: 0, B: 1, O: 1, P: 0 } },
        { id: 'power',   label: 'I’m technical — APIs, automations, code', w: { C: 0, B: 1, O: 2, P: 0 } }
      ]
    },
    {
      id: 'name',
      title: 'Last one — what should we call you?',
      input: { placeholder: 'Your first name (optional)' }
    }
  ];

  /* ---------------- content bank ---------------- */

  var STRENGTH_LINES = {
    build:    { on: 'building and fixing things until they actually work', drain: 'work where you never get to build anything of your own' },
    create:   { on: 'making things people can see and feel — visuals, stories, design', drain: 'invisible work that nobody ever sees or reacts to' },
    teach:    { on: 'explaining things and watching them click for someone', drain: 'working in isolation with no one to share progress with' },
    solve:    { on: 'cracking problems other people gave up on', drain: 'repetitive tasks with no puzzle left in them' },
    optimize: { on: 'turning chaos into clean, working systems', drain: 'messy environments that resist any structure' }
  };

  /* ---- behavior profiles (non-clinical mirrors) ---- */

  var SPARK_ECHO = {
    allin:  'you go all-in for days and then suddenly lose interest',
    plan:   'you research and plan a lot before you dare to start',
    quick:  'you need quick results or you drop things',
    steady: 'you move slowly but rarely quit',
    paral:  'you often feel overwhelmed and don’t start at all'
  };
  var GRAVEYARD_ECHO = {
    day3:    'your projects usually die on day 3, when the novelty wears off',
    middle:  'your projects usually die in the boring middle part',
    perfect: 'you polish forever and never actually ship',
    shiny:   'a newer, shinier idea usually steals you away',
    rarely:  'your projects don’t really die — they just move slowly'
  };

  var PROFILES = {
    sprinter: {
      name: 'The Sprinter',
      mirror: [
        'Your motivation runs on novelty. When something is new, your brain lights up and you can outwork anyone — you’ve probably had 48-hour stretches that amazed people around you. Then, around day 3, the newness chemical drops, the project suddenly feels heavier, and a voice says “maybe this isn’t it.” You’ve heard people call that laziness or lack of discipline. It isn’t either.',
        'It’s an interest-driven engine in a world that’s built for schedule-driven ones. The fix is not “try harder” — it’s designing your path so that a visible win lands every 48 hours, so the dopamine never has time to die. That’s exactly how your plan below is built.'
      ],
      adapt: [
        'Every step is sized to produce something you can SEE within 48 hours',
        'One tool at a time — new tools are scheduled as your “novelty refills”',
        'Publishing early replaces perfecting, because feedback is your fuel'
      ],
      on: 'novelty, visible wins, racing the clock',
      drain: 'long invisible grinds with no feedback',
      freeWarn: 'And honestly? Your pattern is the one that quits free self-taught routes fastest — the novelty runs out at week 3, the results arrive at month 6, and the gap between those two kills the project. You need the shortcut more than anyone.'
    },
    overthinker: {
      name: 'The Overthinker',
      mirror: [
        'Your problem was never laziness — it’s that you refuse to start before you can do it “properly.” You collect tutorials, compare tools, plan the perfect setup… and the start date quietly slides. When you do finish something, you keep polishing it long past the point where anyone would have shipped. Underneath it all is a high standard — you just aim it at yourself before you’ve even begun.',
        'The cure isn’t more information. It’s removing decisions. When the stack is already chosen, the first task is already defined, and someone is expecting your output on a date — you move fast, because the thinking part of you finally has nothing left to chew on. Your plan below makes every choice for you.'
      ],
      adapt: [
        'Zero tool decisions — your exact stack is pre-selected below, no comparisons needed',
        'Day 1 includes shipping something small and imperfect, on purpose',
        'External deadlines (a session, a published date) replace self-imposed “when it’s ready”'
      ],
      on: 'clarity, pre-made decisions, high standards pointed at real work',
      drain: 'open-ended choices and “figure it out yourself” instructions',
      freeWarn: 'The free route is dangerous for your pattern in a sneaky way: unlimited videos means unlimited research, and unlimited research is where your projects go to hide. A fixed curriculum closes that escape hatch.'
    },
    scattered: {
      name: 'The Explorer',
      mirror: [
        'Your problem isn’t a lack of ideas — it’s that you never say goodbye to any of them. Every direction genuinely interests you, so committing to one feels like betraying the others. The result: five projects at 20% and none at 100%. People underestimate how exhausting that is, because from outside it looks like freedom.',
        'Here’s the reframe: choosing one path for 30 days isn’t abandoning the rest — it’s sequencing them. Your plan below locks exactly one route and one tool at a time, with a built-in review point where you’re ALLOWED to pivot. Commitment with an exit door is something your brain can actually sign.'
      ],
      adapt: [
        'One path, one tool, 30 days — pivoting is scheduled, not spontaneous',
        'Each step ends with a finished artifact, so nothing stays at 20%',
        'Your other interests become content/fuel for this path instead of competitors to it'
      ],
      on: 'variety inside a structure, connecting ideas across fields',
      drain: 'being forced to pretend you only have one interest',
      freeWarn: 'Free-roaming YouTube is your kryptonite: every recommended video is a new direction, and your pattern says yes to all of them. A single fixed path is the only version of this that ends with something finished.'
    },
    grinder: {
      name: 'The Grinder',
      mirror: [
        'You’re the rarest pattern here: you don’t quit. You move slower than the hype crowd, you don’t chase shiny tools, and you finish what you start — eventually. Your risk isn’t abandoning the path; it’s spending a year on a route that should have taken six weeks, simply because nobody showed you the shortcuts.',
        'So here’s the honest version: you’re the one person who COULD survive the free self-taught route. The only question is whether you want to pay for the shortcut with money or with a year of your evenings. Your plan below assumes your consistency and optimizes purely for time.'
      ],
      adapt: [
        'Longer arcs are fine for you — steps are sequenced for depth, not dopamine',
        'Weekly rhythm over daily streaks: your consistency is the engine',
        'We cut everything optional — your time is the only thing worth protecting'
      ],
      on: 'steady visible mastery, a clear sequence, no wasted motion',
      drain: 'chaotic pivots and hype-driven tool switching',
      freeWarn: 'Truth: your pattern can survive the free route — you’re the exception. But budget 12–18 months of evenings for what a structured path does in 6 weeks. Only you can say what your year is worth.'
    },
    escape: {
      name: 'The Escape Artist',
      mirror: [
        'When a task is boring, you don’t grind through it — you engineer your way out of it. People call that avoidance; in the AI era it has a different name: talent. The entire point of agents and automation is to make boring work optional, and you’ve been training for that mindset your whole life.',
        'Your real constraint is time, and your real skill is delegation. So your plan below doesn’t ask for discipline you don’t have hours for — it asks for 30-minute focused blocks where you build the machine once, and the machine does the boring part forever after.'
      ],
      adapt: [
        '30-minute blocks, never marathon sessions — built for a real calendar',
        'Automation-first ordering: the first thing you build removes your most boring task',
        'Every step delegates more of the path itself to AI working for you'
      ],
      on: 'leverage — one hour of building that deletes ten hours of chores',
      drain: 'manual repetitive work that a machine should be doing',
      freeWarn: 'The free route costs the one thing you don’t have: time. Hunting knowledge across hundreds of videos IS the boring task — and your pattern will (correctly) refuse to do it.'
    }
  };
  var NONCLINICAL = 'This is a behavioral mirror based on your answers — not a clinical assessment of any kind.';

  var VALUE_LINES = {
    freedom:   'you’re wired for autonomy — you do your best work when you design the conditions of your own day',
    growth:    'you’re wired for mastery — what keeps you going is the feeling of getting measurably better',
    stability: 'you build best from solid ground — you want each step to make your position stronger, not riskier',
    impact:    'you’re fueled by impact — you need your work to land in front of real people and change something'
  };

  var STRUGGLE_LINES = {
    start:      'The reason you haven’t started isn’t laziness — it’s that nobody ever showed you a first step small enough to actually take today.',
    directions: 'Your problem was never a lack of options — it’s that every option looked equally possible. What you’ve been missing is a filter, and your answers just built one.',
    finish:     'You don’t abandon things because you’re weak — you abandon them when they stop giving you visible progress. Your path below is designed around quick, visible wins for exactly that reason.',
    technical:  'The "I’m not technical enough" story ends today — the modern AI stack is operated in plain language, and your plan below never assumes you can code.',
    time:       'You don’t need more hours — you need a path where 30 focused minutes actually compound instead of evaporating. That’s how your plan below is built.'
  };

  var ARCHETYPES = {
    C: {
      key: 'creator',
      name: 'The Creator',
      color: '#c2571f',
      rarity: 18,
      tagline: 'You turn attention into value — AI is about to become your production studio.',
      essence: 'Your answers point in one clear direction: you are built to make things people watch, feel and share. Where others see AI as a calculator, you see a camera crew, an editor and a design team that never sleeps.',
      edgeCore: 'Most people learning AI drown in tools. Your advantage is that you don’t need a hundred tools — you need a repeatable content pipeline: idea → script → visuals → publish. Once that loop runs, every hour you put in compounds into audience, and audience converts into income.',
      pathFoundation: [
        { t: 'Get your AI fundamentals in 7 days', d: 'Prompting, image models, video models — just enough theory to stop feeling lost. No code, no math.', cta: null },
        { t: 'Master the content pipeline', d: 'The AI Content Creation course: build your idea-to-published pipeline once, then reuse it forever — thumbnails, scripts, reels, voice, editing.', cta: 'content' },
        { t: 'Publish your first 10 pieces', d: 'Ten published pieces in 30 days. Not perfect — published. This is where your taste and your niche reveal themselves.', cta: null },
        { t: 'Pressure-test with a coach', d: 'One coffee session: we review your first pieces together and fix your niche, hooks and packaging before you scale.', cta: 'coffee' },
        { t: 'Systemize with automation', d: 'The AI Infrastructure course: schedule, repurpose and distribute automatically, so one idea becomes five assets without you touching it.', cta: 'infra' },
        { t: 'Monetize', d: 'Sponsors, products, services or your own course — pick the model that fits the audience you’ve built.', cta: null }
      ],
      pathDirect: [
        { t: 'Audit and upgrade your pipeline', d: 'You already use AI — now make it a system. Map your current workflow and find the three biggest leaks.', cta: null },
        { t: 'Go pro on production', d: 'The AI Content Creation course: consistent characters, cinematic video, voice — the level most creators never reach.', cta: 'content' },
        { t: '30-day publishing sprint', d: 'Ship daily or near-daily using the pipeline. Volume plus feedback is the fastest teacher in the game.', cta: null },
        { t: 'Automate distribution', d: 'The AI Infrastructure course: one piece in, five platforms out — automatically.', cta: 'infra' },
        { t: 'Scale with a coach', d: 'Coffee sessions as your editorial board: niche, offers and growth decisions, one-on-one.', cta: 'coffee' }
      ],
      toolbox: ['ChatGPT / Claude — scripts & hooks', 'CapCut — editing & captions', 'Midjourney / Nano Banana — images', 'Higgsfield — AI video', 'ElevenLabs — voice & dubbing', 'n8n — auto-distribution'],
      week: {
        light:    ['Day 1–2: watch one pipeline breakdown, pick your niche shortlist (30 min/day)', 'Day 3–4: generate your first 10 images around one idea', 'Day 5–6: turn the best one into a 20-second video', 'Day 7: publish it. Done beats perfect.'],
        standard: ['Day 1: pick one niche and one format (reel / short / carousel)', 'Day 2–3: build your first idea → script → visual pipeline', 'Day 4–5: produce two full pieces end-to-end', 'Day 6: publish both, note what felt slow', 'Day 7: fix the slowest step — that’s your first automation candidate'],
        intense:  ['Day 1: niche + format + 10 idea backlog', 'Day 2–3: build the full pipeline and produce 3 pieces', 'Day 4–5: publish daily, iterate hooks each time', 'Day 6: A/B two thumbnail/hook styles', 'Day 7: review analytics, double down on the winner — and book your strategy coffee']
      }
    },
    B: {
      key: 'builder',
      name: 'The Builder',
      color: '#1f6e8c',
      rarity: 12,
      tagline: 'You don’t want to use AI — you want to build the machine that uses AI.',
      essence: 'Your answers show a maker’s pattern: you’re happiest when something you assembled starts running on its own. In the AI economy, that instinct has a name — agent builder — and it’s one of the most valuable skills on the market right now.',
      edgeCore: 'While everyone else is chatting with AI, you can be the person who wires AI into agents and automations that work while you sleep — for your own projects first, then for clients who will happily pay for the hours your systems save them.',
      pathFoundation: [
        { t: 'Understand the moving parts', d: 'LLMs, prompts, APIs, triggers — a plain-language map of how agents actually work. No computer science required.', cta: null },
        { t: 'Build your first automation', d: 'The AI Infrastructure course: your first real workflow (n8n-style) — a bot that does one boring task for you, end to end.', cta: 'infra' },
        { t: 'Ship one agent that matters', d: 'Pick one painful, repeated task in your life or work and kill it with an agent. This is your proof-of-work.', cta: null },
        { t: 'Architecture review over coffee', d: 'One coffee session: we review your agent’s design together and make it production-grade.', cta: 'coffee' },
        { t: 'Learn to package and present', d: 'The AI Content Creation course: demo videos and case studies — because a builder who can show their work gets clients.', cta: 'content' },
        { t: 'First client or product', d: 'Turn your working agent into a service or micro-product. One real user changes everything.', cta: null }
      ],
      pathDirect: [
        { t: 'Level up from automations to agents', d: 'The AI Infrastructure course: multi-step agents, memory, tool use and error handling — the difference between a demo and a system.', cta: 'infra' },
        { t: 'Build the flagship', d: 'One serious agent for a real workflow — yours or a client’s. Scope it small, make it bulletproof.', cta: null },
        { t: 'Harden it with a coach', d: 'Coffee session: architecture, edge cases and deployment review, one-on-one.', cta: 'coffee' },
        { t: 'Package your proof', d: 'The AI Content Creation course: turn your builds into demos and case studies that sell for you.', cta: 'content' },
        { t: 'Sell it', d: 'Productize: fixed-scope agent builds, retainers, or your own SaaS-style micro-product.', cta: null }
      ],
      toolbox: ['ChatGPT / Claude — prompt design', 'n8n — workflows & agents', 'Claude Code — agentic building', 'Webhooks & APIs — the wiring', 'Vector DB — agent memory'],
      week: {
        light:    ['Day 1–2: list every task you repeat weekly, pick the most annoying (30 min/day)', 'Day 3–4: sketch the workflow on paper — trigger, steps, output', 'Day 5–6: build the simplest version of step one', 'Day 7: run it for real once. You’re officially building.'],
        standard: ['Day 1: pick one repeated task with a clear trigger', 'Day 2–3: build the happy path of your first automation', 'Day 4: add the AI step — summarize, draft, classify or decide', 'Day 5–6: handle the two most likely failure cases', 'Day 7: let it run unattended for a day, then review the log'],
        intense:  ['Day 1: map three candidate workflows, choose one', 'Day 2–3: build the full pipeline with an LLM step', 'Day 4: add memory or a second tool', 'Day 5: break it on purpose, fix what fails', 'Day 6: write a one-page case study of what it saves', 'Day 7: demo it to one real person — and book your architecture coffee']
      }
    },
    O: {
      key: 'operator',
      name: 'The Operator',
      color: '#4a3c8f',
      rarity: 9,
      tagline: 'Your edge isn’t one skill — it’s doing everything agentically, 10× faster than the room.',
      essence: 'Your answers reveal the rarest pattern here: you don’t want to be a content person or an agency — you want AI woven into how you think and execute everything. Research, writing, building, deciding — delegated to agents you direct like a small team.',
      edgeCore: 'The agentic way of working — directing tools like Claude Code instead of doing everything by hand — is what separates people who "use AI" from people who operate at a different speed. You learn to brief, delegate, review and ship. That skill transfers to every project you’ll ever touch.',
      pathFoundation: [
        { t: 'Adopt the agentic mindset', d: 'Stop thinking "which tool?" and start thinking "what’s the brief?" — learn to delegate to AI the way a director delegates to a crew.', cta: null },
        { t: 'Set up your command center', d: 'The AI Infrastructure course: your personal stack — an agentic terminal (Claude Code-style), automations, and knowledge base wired together.', cta: 'infra' },
        { t: 'Run a real project agentically', d: 'Pick one project and complete it end-to-end by directing agents: research, drafts, assets, delivery.', cta: null },
        { t: 'Workflow review over coffee', d: 'One coffee session: we watch how you work and remove the friction you can’t see yourself.', cta: 'coffee' },
        { t: 'Add a public layer', d: 'The AI Content Creation course: document what you build — operators who show their workflow become magnets for opportunities.', cta: 'content' },
        { t: 'Compound', d: 'Every project adds agents, templates and playbooks to your arsenal. Your speed advantage grows monthly.', cta: null }
      ],
      pathDirect: [
        { t: 'Formalize your stack', d: 'The AI Infrastructure course: turn your scattered AI usage into one coherent agentic system — terminal, automations, memory.', cta: 'infra' },
        { t: 'Ship something impossible', d: 'Pick a project that would normally take a month. Ship it in a week by directing agents. That’s your new baseline.', cta: null },
        { t: 'Get audited', d: 'Coffee session: a second pair of eyes on your workflow — the fastest way to find your blind spots.', cta: 'coffee' },
        { t: 'Teach it forward', d: 'The AI Content Creation course: turn your workflow into content — the operator who documents becomes the authority.', cta: 'content' },
        { t: 'Monetize the speed', d: 'Consulting, done-for-you sprints, or building products at a pace competitors can’t match.', cta: null }
      ],
      toolbox: ['Claude Code — your command center', 'n8n — background automations', 'ChatGPT / Claude — research & drafts', 'Knowledge base — your second brain', 'Multi-agent delegation'],
      week: {
        light:    ['Day 1–2: write briefs instead of doing tasks — delegate two small things to AI daily', 'Day 3–4: build one reusable prompt/agent for a recurring task', 'Day 5–6: run a mini-project fully delegated', 'Day 7: review — what did you touch that you shouldn’t have?'],
        standard: ['Day 1: list your week’s tasks, mark everything delegable', 'Day 2–3: set up your agentic workspace and delegate for real', 'Day 4–5: run one full deliverable through brief → delegate → review → ship', 'Day 6: template what worked', 'Day 7: measure hours saved. That number only grows from here'],
        intense:  ['Day 1: pick a one-month project to ship in one week', 'Day 2–4: run it agentically — parallel agents, tight review loops', 'Day 5: ship it', 'Day 6: write the playbook of how it was done', 'Day 7: plan the next impossible thing — and book your workflow-audit coffee']
      }
    },
    P: {
      key: 'professional',
      name: 'The Professional',
      color: '#3e7d43',
      rarity: 15,
      tagline: 'You’re not changing careers — you’re about to make yours impossible to compete with.',
      essence: 'Your answers show something most people miss about AI: the biggest wins don’t go to people who abandon their field — they go to people who bring AI back into a field they already know deeply. Your experience is the moat; AI is the multiplier.',
      edgeCore: 'A generalist with AI competes with millions. A specialist with AI competes with almost no one — because your years of domain judgment are exactly what AI can’t fake. The plan below layers AI onto your expertise, not instead of it.',
      pathFoundation: [
        { t: 'See your field through AI eyes', d: 'A structured tour of what AI already does in your industry — and the gap nobody in your market is filling yet.', cta: null },
        { t: 'Learn the visible layer first', d: 'The AI Content Creation course: presentations, visuals and client-facing material at a level your competitors can’t match.', cta: 'content' },
        { t: 'Apply it to one live project', d: 'Use AI on a real client project this month — quietly. Measure the hours saved and the reaction you get.', cta: null },
        { t: 'Strategy session over coffee', d: 'One coffee session: we map YOUR services to specific AI leverage points — a personal playbook for your niche.', cta: 'coffee' },
        { t: 'Automate the back office', d: 'The AI Infrastructure course: proposals, follow-ups, reporting — the invisible 40% of your week, automated.', cta: 'infra' },
        { t: 'Raise your position', d: 'New pricing, new packaging, and a public signal that you’re the AI-forward expert in your niche.', cta: null }
      ],
      pathDirect: [
        { t: 'Map your leverage points', d: 'Audit your service delivery end-to-end: where does AI 10× you — visuals, drafts, analysis, communication?', cta: null },
        { t: 'Upgrade the client-facing layer', d: 'The AI Content Creation course: make everything a client sees — decks, renders, proposals — unmistakably next-level.', cta: 'content' },
        { t: 'Automate operations', d: 'The AI Infrastructure course: intake, follow-ups, reporting and handoffs running without you.', cta: 'infra' },
        { t: 'Personal playbook with a coach', d: 'Coffee sessions: build your niche-specific AI playbook, decision by decision, with someone who’s done it.', cta: 'coffee' },
        { t: 'Own the niche', d: 'Publish your AI-augmented work. In a conservative industry, the first credible mover takes a disproportionate share.', cta: null }
      ],
      toolbox: ['ChatGPT / Claude — drafts & analysis', 'Midjourney / Nano Banana — visuals', 'Higgsfield — presentation video', 'n8n — office automation', 'Domain AI tools for your field'],
      week: {
        light:    ['Day 1–2: list your 5 most repeated professional tasks (30 min/day)', 'Day 3–4: use AI on the easiest one — a draft, a visual, a summary', 'Day 5–6: use the output in real work once', 'Day 7: note the hours saved. Multiply by 52. That’s the case for going deeper.'],
        standard: ['Day 1: audit one full client project for AI leverage points', 'Day 2–3: upgrade one client-facing deliverable with AI', 'Day 4–5: automate one back-office task', 'Day 6: quietly ship both into real work', 'Day 7: review reactions and hours saved — pick next month’s target'],
        intense:  ['Day 1: full service-delivery audit, pick 3 leverage points', 'Day 2–3: rebuild your flagship deliverable with AI', 'Day 4: automate intake or follow-up end-to-end', 'Day 5: use both on a live project', 'Day 6: document the before/after', 'Day 7: draft your new positioning — and book your strategy coffee']
      }
    }
  };

  /* concrete tools to learn at each path step, per archetype x level.
     index-aligned with pathFoundation / pathDirect */
  var STEP_TOOLS = {
    C: {
      foundation: [['ChatGPT / Claude'], ['Midjourney / Nano Banana', 'Higgsfield'], ['CapCut', 'ElevenLabs'], [], ['n8n'], []],
      direct: [['ChatGPT / Claude'], ['Higgsfield', 'Midjourney / Nano Banana'], ['CapCut', 'ElevenLabs'], ['n8n'], []]
    },
    B: {
      foundation: [['ChatGPT / Claude'], ['n8n'], ['n8n', 'Claude Code'], [], ['Higgsfield', 'CapCut'], []],
      direct: [['n8n', 'Claude Code'], ['Claude Code'], [], ['Higgsfield', 'CapCut'], []]
    },
    O: {
      foundation: [['ChatGPT / Claude'], ['Claude Code', 'n8n'], ['Claude Code'], [], ['Higgsfield', 'CapCut'], []],
      direct: [['Claude Code', 'n8n'], ['Claude Code'], [], ['CapCut', 'Higgsfield'], []]
    },
    P: {
      foundation: [['ChatGPT / Claude'], ['Midjourney / Nano Banana', 'Higgsfield'], [], [], ['n8n'], []],
      direct: [['ChatGPT / Claude'], ['Midjourney / Nano Banana', 'Higgsfield'], ['n8n'], [], []]
    }
  };

  /* field-specific note injected into the Professional (and lightly into others) */
  var FIELD_NOTES = {
    design: 'In architecture and interior design specifically, the leverage is brutal: AI renders in minutes instead of days, mood boards on demand, 3D-ready presentations — while most of your market still renders overnight.',
    tech:   'With a technical background, you can skip the gentle intro — your fastest wins are agentic workflows and automation, where your existing skills compound immediately.',
    biz:    'In marketing and business, AI is already table stakes — your edge comes from operating it systematically: content pipelines, lead automation and reporting that runs itself.',
    none:   'No field yet is an advantage in disguise: you get to pick a niche with AI leverage built in from day one, instead of retrofitting an old workflow.',
    other:  'Whatever your field, the pattern holds: the deeper your domain knowledge, the more unfair AI makes your advantage.'
  };

  var RARITY_TEXT = { C: 18, B: 12, O: 9, P: 15 };

  /* ---------------- engine ---------------- */

  function computeResult(answers) {
    var scores = { C: 0, B: 0, O: 0, P: 0 };
    QUESTIONS.forEach(function (q) {
      if (!q.options) return;
      var picked = answers[q.id];
      var opt = q.options.filter(function (o) { return o.id === picked; })[0];
      if (opt && opt.w) Object.keys(opt.w).forEach(function (k) { scores[k] += opt.w[k]; });
    });
    /* Professional guard: needs a real field */
    if (answers.field === 'none') scores.P -= 3;
    /* winner; tie-break by the direct-desire question (pull) */
    var pullMap = { content: 'C', agents: 'B', faster: 'O', field: 'P' };
    var order = ['C', 'B', 'O', 'P'].sort(function (a, b) {
      if (scores[b] !== scores[a]) return scores[b] - scores[a];
      if (pullMap[answers.pull] === a) return -1;
      if (pullMap[answers.pull] === b) return 1;
      return 0;
    });
    var level = (answers.exp === 'zero' || answers.exp === 'casual') ? 'foundation' : 'direct';
    var pace = (answers.hours === 'h3') ? 'light' : (answers.hours === 'h15p') ? 'intense' : 'standard';
    /* commitment tier (sales ladder): starter -> core -> allin */
    var tier = answers.money === 'asap' ? 'starter' : answers.money === 'not' ? 'allin' : 'core';
    /* behavior profile (non-clinical) from spark/graveyard/boring + struggle/situation */
    var p = { sprinter: 0, overthinker: 0, scattered: 0, grinder: 0, escape: 0 };
    var add = function (k, n) { p[k] += n; };
    ({ allin: function () { add('sprinter', 2); }, plan: function () { add('overthinker', 2); }, quick: function () { add('sprinter', 2); }, steady: function () { add('grinder', 2); }, paral: function () { add('overthinker', 2); } }[answers.spark] || function () { })();
    ({ day3: function () { add('sprinter', 2); }, middle: function () { add('escape', 2); add('sprinter', 1); }, perfect: function () { add('overthinker', 2); }, shiny: function () { add('scattered', 2); }, rarely: function () { add('grinder', 2); } }[answers.graveyard] || function () { })();
    ({ force: function () { add('grinder', 1); }, delay: function () { add('overthinker', 1); add('sprinter', 1); }, gamify: function () { add('sprinter', 1); }, delegate: function () { add('escape', 2); }, grind: function () { add('grinder', 2); } }[answers.boring] || function () { })();
    ({ directions: function () { add('scattered', 2); }, finish: function () { add('sprinter', 2); }, time: function () { add('escape', 2); }, start: function () { add('overthinker', 1); } }[answers.struggle] || function () { })();
    if (answers.situation === 'many') add('scattered', 2);
    var profOrder = ['sprinter', 'scattered', 'overthinker', 'escape', 'grinder'];
    var profile = profOrder[0];
    var best = -1;
    profOrder.forEach(function (k) { if (p[k] > best) { best = p[k]; profile = k; } });
    if (best <= 0) profile = 'grinder';
    return { archetype: order[0], runnerUp: order[1], scores: scores, level: level, pace: pace, tier: tier, profile: profile, profileScores: p };
  }

  /* ---------------- component ---------------- */

  function AiPathQuiz(root) {
    this.root = root;
    this.urls = {
      content: root.dataset.courseContentUrl || '',
      infra: root.dataset.courseInfraUrl || '',
      coffee: root.dataset.coffeeUrl || '',
      coffee5: root.dataset.coffee5Url || root.dataset.coffeeUrl || '',
      youtube: root.dataset.youtubeUrl || ''
    };
    this.coffeeSeats = root.dataset.coffeeSeats || '';
    this.video = {
      id: parseYouTubeId(root.dataset.videoUrl || ''),
      cover: root.dataset.videoCover || '',
      heading: root.dataset.videoHeading || 'Your full path is ready',
      text: root.dataset.videoText || 'Watch this short video first — press play and your full path unlocks.'
    };
    this.leadMagnet = {
      heading: root.dataset.leadHeading || 'Free bonus: the $48 UGC + Prompting tutorial',
      text: root.dataset.leadText || 'Enter your number and it’s yours, free.',
      consent: root.dataset.leadConsent || 'I agree to receive marketing messages from Peeshee about my AI path and related offers.'
    };
    this.downloadUrl = root.dataset.downloadUrl || '';
    this.giftImage = root.dataset.giftImage || '';
    this.webhookUrl = root.dataset.webhookUrl || '';
    this.scenes = {
      landing: root.querySelector('[data-scene="landing"]'),
      quiz: root.querySelector('[data-scene="quiz"]'),
      analyzing: root.querySelector('[data-scene="analyzing"]'),
      report: root.querySelector('[data-scene="report"]')
    };
    this.stepEl = root.querySelector('[data-quiz-step]');
    this.barEl = root.querySelector('[data-progress-fill]');
    this.pctEl = root.querySelector('[data-progress-pct]');
    this.backBtn = root.querySelector('[data-quiz-back]');
    this.reportEl = root.querySelector('[data-report]');

    var saved = this.load();
    this.answers = saved.answers || {};
    this.step = saved.step || 0;
    if (!this.answers.__sid) this.answers.__sid = makeSessionId();

    this.bind();
    this.route();
  }

  AiPathQuiz.prototype.load = function () {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  };
  AiPathQuiz.prototype.save = function () {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ answers: this.answers, step: this.step })); } catch (e) { }
  };

  AiPathQuiz.prototype.bind = function () {
    var self = this;
    this.root.querySelector('[data-start]').addEventListener('click', function () {
      self.show('quiz');
      self.renderStep();
    });
    this.backBtn.addEventListener('click', function () {
      if (self.step > 0) { self.step--; self.save(); self.renderStep(); }
    });
  };

  AiPathQuiz.prototype.route = function () {
    var self = this;
    var showReport = function () {
      self.runAnalyzing(function () {
        self.show('report');
        self.renderReport();
      });
    };
    var params = new URLSearchParams(location.search);
    var r = params.get('r');
    if (r) {
      try {
        var decoded = JSON.parse(atob(r.replace(/-/g, '+').replace(/_/g, '/')));
        var prior = this.answers || {};
        this.answers = decoded;
        this.answers.__sid = prior.__sid || makeSessionId();
        if (prior.__unlocked) this.answers.__unlocked = true;
        if (prior.__phoneSent) { this.answers.__phoneSent = true; this.answers.__phone = prior.__phone; }
        this.save();
        showReport();
        return;
      } catch (e) { /* fall through */ }
    }
    var done = QUESTIONS.every(function (q) { return q.input || this.answers[q.id] !== undefined; }, this) && this.answers.__done;
    if (done) showReport();
    else this.show('landing');
  };

  AiPathQuiz.prototype.show = function (name) {
    var s = this.scenes;
    Object.keys(s).forEach(function (k) { s[k].hidden = k !== name; });
    window.scrollTo(0, 0);
  };

  /* ---------------- quiz rendering ---------------- */

  AiPathQuiz.prototype.renderStep = function () {
    var self = this;
    var q = QUESTIONS[this.step];
    var total = QUESTIONS.length;
    var pct = Math.round((this.step / total) * 100);
    this.barEl.style.width = pct + '%';
    this.pctEl.textContent = pct + '%';
    this.backBtn.hidden = this.step === 0;

    var html = '<div class="apq-card" data-anim>';
    html += '<h2 class="apq-q-title">' + q.title + '</h2>';

    if (q.input) {
      html += '<input class="apq-input" type="text" maxlength="30" placeholder="' + q.input.placeholder + '" data-name-input>';
      html += '<button class="apq-next" type="button" data-finish>See my analysis →</button>';
    } else {
      html += '<div class="apq-options">';
      q.options.forEach(function (o) {
        var sel = self.answers[q.id] === o.id ? ' is-selected' : '';
        html += '<button type="button" class="apq-option' + sel + '" data-opt="' + o.id + '"><span class="apq-radio"></span>' + o.label + '</button>';
      });
      html += '</div>';
      if (q.textarea) {
        html += '<p class="apq-textarea-label">' + q.textarea.label + '</p>';
        html += '<textarea class="apq-textarea" rows="3" maxlength="280" placeholder="' + q.textarea.placeholder + '" data-dream-input>' + (this.answers.__dream || '') + '</textarea>';
        html += '<button class="apq-next" type="button" data-next hidden>→ Next</button>';
      }
    }
    html += '</div>';
    this.stepEl.innerHTML = html;

    if (q.input) {
      var inp = this.stepEl.querySelector('[data-name-input]');
      inp.value = this.answers.__name || '';
      inp.focus();
      this.stepEl.querySelector('[data-finish]').addEventListener('click', function () {
        self.answers.__name = inp.value.trim();
        self.finish();
      });
      return;
    }

    var nextBtn = this.stepEl.querySelector('[data-next]');
    var dream = this.stepEl.querySelector('[data-dream-input]');
    Array.prototype.forEach.call(this.stepEl.querySelectorAll('.apq-option'), function (btn) {
      btn.addEventListener('click', function () {
        self.answers[q.id] = btn.dataset.opt;
        Array.prototype.forEach.call(self.stepEl.querySelectorAll('.apq-option'), function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (dream) {
          /* question with textarea: reveal Next instead of auto-advance */
          nextBtn.hidden = false;
          nextBtn.focus();
        } else {
          setTimeout(function () { self.advance(); }, 180);
        }
      });
    });
    if (nextBtn) {
      if (this.answers[q.id]) nextBtn.hidden = false;
      nextBtn.addEventListener('click', function () {
        if (dream) self.answers.__dream = dream.value.trim();
        self.advance();
      });
    }
  };

  AiPathQuiz.prototype.advance = function () {
    this.step++;
    this.save();
    if (this.step >= QUESTIONS.length) this.finish();
    else this.renderStep();
  };

  AiPathQuiz.prototype.finish = function () {
    this.answers.__done = true;
    this.save();
    this.sendLead();
    var self = this;
    this.runAnalyzing(function () {
      self.show('report');
      self.renderReport();
    });
  };

  /* 5-second analysis: progress bar + staged messages, then callback */
  AiPathQuiz.prototype.runAnalyzing = function (done) {
    var DURATION = 5000;
    this.show('analyzing');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { setTimeout(done, 300); return; }
    var scene = this.scenes.analyzing;
    var h2 = scene.querySelector('h2');
    var desc = scene.querySelector('.apq-analyze-desc') || scene.querySelector('h2 + p');
    var fill = scene.querySelector('[data-analyze-fill]');
    var pct = scene.querySelector('[data-analyze-pct]');
    var stages = [
      ['Reading your answers…', 'Mapping your strengths against the four AI paths.'],
      ['Detecting your pattern…', 'Comparing how you start, where projects die, and what drains you.'],
      ['Scoring the four paths…', 'Creator, Builder, Operator, Professional — weighing every answer.'],
      ['Building your route…', 'Choosing your tools, your order, and your first 7 days.']
    ];
    /* wall-clock interval, NOT requestAnimationFrame: rAF gets frozen by
       Chrome Energy Saver / battery mode and the bar would stall forever */
    var start = Date.now();
    var timer = setInterval(function () {
      var t = Math.min((Date.now() - start) / DURATION, 1);
      /* ease-out so the bar feels like real work, slowing near the end */
      var eased = 1 - Math.pow(1 - t, 2.2);
      var percent = Math.max(0, Math.round(eased * 100));
      if (fill) fill.style.width = percent + '%';
      if (pct) pct.textContent = percent + '%';
      var stage = stages[Math.min(Math.floor(t * stages.length), stages.length - 1)];
      if (h2 && h2.textContent !== stage[0]) {
        h2.textContent = stage[0];
        if (desc) desc.textContent = stage[1];
      }
      if (t >= 1) { clearInterval(timer); done(); }
    }, 50);
  };

  AiPathQuiz.prototype.sendLead = function () {
    this.postWebhook(this.buildLeadSnapshot('quiz_completed'));
  };

  AiPathQuiz.prototype.postWebhook = function (payload) {
    if (!this.webhookUrl) return;
    try {
      var body = JSON.stringify(payload);
      /* Content-Type must be a CORS-"simple" type (text/plain), NOT
         application/json — application/json forces the browser to send a
         preflight OPTIONS request first, and endpoints that only answer
         POST (Google Apps Script Web Apps, many n8n webhook nodes) never
         respond to that preflight, so the real POST silently never goes
         out at all. Sending as text/plain skips the preflight entirely;
         the body is still valid JSON text and every receiver here
         (Apps Script's e.postData.contents, n8n's raw body, etc.) reads
         and JSON.parses it exactly the same either way. */
      if (navigator.sendBeacon) navigator.sendBeacon(this.webhookUrl, new Blob([body], { type: 'text/plain;charset=utf-8' }));
      else fetch(this.webhookUrl, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body, keepalive: true });
    } catch (e) { }
  };

  function makeSessionId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) { }
    return 'sid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* One flat, spreadsheet-friendly snapshot of everything known about this
     person so far — shared by both webhook calls (quiz completion and
     phone capture) and keyed by __sid, so a log destination (a Sheet, a
     CRM…) can join "this phone number" back to "these exact answers"
     even though the two events arrive as separate HTTP requests. */
  AiPathQuiz.prototype.buildLeadSnapshot = function (eventName) {
    var a = this.answers;
    var res = computeResult(a);
    return {
      event: eventName,
      sid: a.__sid,
      ts: new Date().toISOString(),
      name: a.__name || '',
      channel: a.__giftChannel || '',
      phone: a.__phone || '',
      email: a.__email || '',
      consent: !!a.__phoneSent,
      archetype: res.archetype,
      archetypeName: (ARCHETYPES[res.archetype] || {}).name || '',
      profile: res.profile,
      tier: res.tier,
      level: res.level,
      pace: res.pace,
      money: a.money || '', flow: a.flow || '', pull: a.pull || '', struggle: a.struggle || '',
      spark: a.spark || '', graveyard: a.graveyard || '', value: a.value || '', field: a.field || '', exp: a.exp || '',
      dream: a.__dream || '',
      pageUrl: location.href
    };
  };

  /* ---------------- report rendering ---------------- */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  AiPathQuiz.prototype.renderReport = function () {
    var a = this.answers;
    var res = computeResult(a);
    var A = ARCHETYPES[res.archetype];
    var name = (a.__name || '').trim();
    var possessive = name ? esc(name) + '’s' : 'Your';
    var strength = STRENGTH_LINES[a.flow] || STRENGTH_LINES.build;
    var prof = PROFILES[res.profile] || PROFILES.grinder;
    var valueLine = VALUE_LINES[a.value] || VALUE_LINES.growth;
    var struggleLine = STRUGGLE_LINES[a.struggle] || STRUGGLE_LINES.start;
    var fieldNote = FIELD_NOTES[a.field] || FIELD_NOTES.other;
    var path = res.level === 'foundation' ? A.pathFoundation : A.pathDirect;
    var week = A.week[res.pace];
    var self = this;

    var ctaLabel = { content: 'Open the Content Creation course', infra: 'Open the AI Infrastructure course', coffee: 'Book a coffee session' };

    var html = '';
    html += '<div class="apq-report-head" style="--apq-accent:' + A.color + '">';
    html += '<p class="apq-r-kicker">' + possessive + ' AI Path Analysis</p>';
    html += '<h1 class="apq-r-title">You are <span>' + A.name + '</span></h1>';
    html += '<p class="apq-r-tagline">' + A.tagline + '</p>';
    html += '<p class="apq-r-badge">✦ We see this pattern in only ' + A.rarity + '% of people</p>';
    html += '</div>';

    /* -- the mirror: behavioral pattern, echoing their own answers -- */
    html += '<section class="apq-r-section apq-r-pattern"><h3>Your pattern: ' + prof.name + '</h3>';
    var echoes = [];
    if (SPARK_ECHO[a.spark]) echoes.push(SPARK_ECHO[a.spark]);
    if (GRAVEYARD_ECHO[a.graveyard]) echoes.push(GRAVEYARD_ECHO[a.graveyard]);
    if (echoes.length) html += '<p class="apq-r-echo">You told us that ' + echoes.join(', and that ') + '. Read this part carefully — it explains more than you think.</p>';
    prof.mirror.forEach(function (m) { html += '<p>' + m + '</p>'; });
    html += '<div class="apq-r-adapt"><h4>How your plan below is adapted to this</h4><ul>';
    prof.adapt.forEach(function (x) { html += '<li>' + x + '</li>'; });
    html += '</ul></div>';
    html += '<p class="apq-r-disclaimer">' + NONCLINICAL + '</p></section>';

    /* everything below the pattern is gated behind the video (if configured) */
    var gate = this.gateActive();
    if (gate) html += '<div class="apq-locked" data-locked><div class="apq-locked-inner" data-locked-start>';

    html += '<section class="apq-r-section"><h3>What we discovered about you</h3><p>' + A.essence + '</p>';
    html += '<p class="apq-r-value">' + valueLine.charAt(0).toUpperCase() + valueLine.slice(1) + '.</p></section>';

    html += '<section class="apq-r-section apq-r-edge"><h3>Your edge</h3>';
    html += '<p>' + struggleLine + '</p><p>' + A.edgeCore + '</p>';
    html += '<p>' + fieldNote + '</p></section>';

    html += '<section class="apq-r-section apq-r-cols">';
    html += '<div class="apq-r-col apq-r-on"><h4>⚡ Energized by</h4><ul>';
    html += '<li>' + cap(strength.on) + '</li><li>' + cap(prof.on) + '</li><li>Work that lines up with ' + (a.value === 'freedom' ? 'your autonomy' : a.value === 'growth' ? 'visible mastery' : a.value === 'stability' ? 'solid, compounding ground' : 'real impact on real people') + '</li>';
    html += '</ul></div>';
    html += '<div class="apq-r-col apq-r-off"><h4>🔋 Drained by</h4><ul>';
    html += '<li>' + cap(strength.drain) + '</li><li>' + cap(prof.drain) + '</li><li>Advice written for everyone — which is exactly why this plan isn’t</li>';
    html += '</ul></div></section>';

    if (a.__dream) {
      html += '<section class="apq-r-section apq-r-dream"><h3>Your own words</h3>';
      html += '<blockquote>“' + esc(a.__dream) + '”</blockquote>';
      html += '<p>Keep this sentence. Every step below exists to make that day normal.</p></section>';
    }

    html += '<section class="apq-r-section"><h3>' + (name ? esc(name) + ', your' : 'Your') + ' path</h3>';
    html += res.level === 'foundation'
      ? '<p class="apq-r-note">You told us you’re early in AI — so your path starts from zero. No assumed knowledge, no skipped steps.</p>'
      : '<p class="apq-r-note">You already use AI — so we skip the basics and start where it gets interesting.</p>';
    var stepTools = (STEP_TOOLS[res.archetype] || {})[res.level] || [];
    html += '<ol class="apq-r-path">';
    path.forEach(function (st, i) {
      html += '<li><strong>' + st.t + '</strong><p>' + st.d + '</p>';
      var tools = stepTools[i] || [];
      if (tools.length) {
        html += '<div class="apq-r-step-tools"><span class="apq-r-step-tools-label">Learn here:</span>';
        tools.forEach(function (t) { html += '<span class="apq-r-tool apq-r-tool--step">' + t + '</span>'; });
        html += '</div>';
      }
      if (st.cta && self.urls[st.cta]) html += '<a class="apq-btn apq-btn--step" href="' + self.urls[st.cta] + '">' + ctaLabel[st.cta] + ' →</a>';
      html += '</li>';
    });
    html += '</ol></section>';

    html += '<section class="apq-r-section"><h3>Your toolbox</h3><div class="apq-r-tools">';
    A.toolbox.forEach(function (t) { html += '<span class="apq-r-tool">' + t + '</span>'; });
    html += '</div></section>';

    html += '<section class="apq-r-section apq-r-week"><h3>Your first 7 days</h3>';
    html += '<p class="apq-r-note">' + (res.pace === 'light' ? 'Built for under 3 hours a week — small steps that still compound.' : res.pace === 'intense' ? 'You said 15+ hours a week. Good. This plan uses them.' : 'Built for a few focused hours a week.') + '</p><ul>';
    week.forEach(function (d) { html += '<li>' + d + '</li>'; });
    html += '</ul></section>';

    html += this.renderRoutes(res);
    html += this.renderOffer(res, A, name);

    if (gate) {
      html += '</div><div class="apq-locked-overlay" data-locked-overlay>' +
        '<p class="apq-locked-overlay-title">Your full path, tools and 7-day plan are ready</p>' +
        '<button class="apq-btn" type="button" data-gate-open>▶ Watch the video to unlock</button>' +
        '</div></div>';
    }

    html += this.renderGiftCard();

    html += '<div class="apq-r-foot">';
    html += '<button class="apq-link" type="button" data-copy-link>Copy my result link</button>';
    html += '<button class="apq-link" type="button" data-retake>Retake the quiz</button>';
    html += '</div>';

    this.reportEl.innerHTML = html;
    this.armGiftCard();
    this.bindInlineVideo();

    this.reportEl.querySelector('[data-retake]').addEventListener('click', function () {
      self.answers = {}; self.step = 0; self.save();
      history.replaceState(null, '', location.pathname);
      self.show('landing');
    });
    this.reportEl.querySelector('[data-copy-link]').addEventListener('click', function (e) {
      var compact = {};
      QUESTIONS.forEach(function (q) { if (self.answers[q.id]) compact[q.id] = self.answers[q.id]; });
      if (self.answers.__name) compact.__name = self.answers.__name;
      if (self.answers.__dream) compact.__dream = self.answers.__dream;
      var encoded = btoa(JSON.stringify(compact)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      var url = location.origin + location.pathname + '?r=' + encoded;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        e.target.textContent = 'Link copied ✓';
      }, function () {
        prompt('Copy your link:', url);
      });
    });

    this.armGate();
  };

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------------- gift popup (phone + consent -> download link) ----------------
     Same glassy window as the video gate. Auto-opens near the end of the
     report (a small "Claim it" card in the report can reopen it). They enter
     a phone + tick consent; the number+consent are logged to the lead webhook
     (their list), then the download link is revealed inside the popup. The
     whole feature is off if no download URL is configured — see giftActive(). */

  AiPathQuiz.prototype.giftActive = function () {
    return !!this.downloadUrl;
  };

  /* the small card left in the report itself: a reopen button, or — once
     they've claimed — the download link so they never lose access */
  AiPathQuiz.prototype.renderGiftCard = function () {
    if (!this.giftActive()) return '';
    var lm = this.leadMagnet;
    if (this.answers.__phoneSent) {
      return '' +
        '<section class="apq-r-section apq-leadcapture apq-leadcapture--done">' +
        '<p class="apq-leadcapture-badge">✓ UNLOCKED</p>' +
        '<h3>' + esc(lm.heading) + '</h3>' +
        '<p>Both gifts are yours — grab them below.</p>' +
        '<a class="apq-btn apq-btn--coffee apq-gift-download" href="' + esc(this.downloadUrl) + '" target="_blank" rel="noopener">📥 Get your files →</a>' +
        '</section>';
    }
    return '' +
      '<section class="apq-r-section apq-leadcapture">' +
      '<p class="apq-leadcapture-badge">🎁 FREE BONUS</p>' +
      '<h3>' + esc(lm.heading) + '</h3>' +
      '<p>' + esc(lm.text) + '</p>' +
      '<button class="apq-btn apq-btn--coffee" type="button" data-gift-open>🎁 Unlock my bonuses →</button>' +
      '</section>';
  };

  AiPathQuiz.prototype.giftPopupFormHtml = function () {
    var lm = this.leadMagnet;
    /* the banner image is the hero when set; the text block is a fallback
       that stays visible until the image confirms it loaded (handled in
       buildGiftPopup), so a missing image never leaves an empty popup */
    var img = this.giftImage
      ? '<img class="apq-gift-image" src="' + esc(this.giftImage) + '" alt="Your free bonuses" data-gift-image-el>'
      : '';
    return '' +
      img +
      '<div class="apq-gift-text" data-gift-text>' +
      '<p class="apq-leadcapture-badge">🎁 FREE BONUS</p>' +
      '<h3 class="apq-gate-heading">' + esc(lm.heading) + '</h3>' +
      '<p class="apq-gate-text">' + esc(lm.text) + '</p>' +
      '</div>' +
      '<form class="apq-lead-form" data-gift-form>' +
      '<input class="apq-input" type="tel" inputmode="tel" autocomplete="tel" placeholder="Your phone number (with country code)" data-gift-phone required>' +
      '<label class="apq-consent"><input type="checkbox" data-gift-consent><span>' + esc(lm.consent) + '</span></label>' +
      '<button class="apq-btn apq-btn--coffee" type="submit" data-gift-submit disabled>🔓 Unlock my bonuses now</button>' +
      '</form>';
  };

  AiPathQuiz.prototype.giftPopupDoneHtml = function () {
    return '' +
      '<p class="apq-leadcapture-badge">✓ UNLOCKED</p>' +
      '<h3 class="apq-gate-heading">Your bonuses are ready</h3>' +
      '<p class="apq-gate-text">Both gifts are unlocked — grab them below.</p>' +
      '<a class="apq-btn apq-btn--coffee apq-gift-download" href="' + esc(this.downloadUrl) + '" target="_blank" rel="noopener">📥 Get your files →</a>';
  };

  AiPathQuiz.prototype.buildGiftPopup = function () {
    var self = this;
    if (this.giftEl) this.giftEl.remove();
    var el = document.createElement('div');
    el.className = 'apq-gate-backdrop';
    el.hidden = true;
    el.innerHTML =
      '<div class="apq-gate-card apq-gift-card" role="dialog" aria-modal="true">' +
      '<button class="apq-gate-close" type="button" data-gift-close aria-label="Close">&times;</button>' +
      '<div data-gift-body>' + this.giftPopupFormHtml() + '</div>' +
      '</div>';
    this.root.appendChild(el);
    this.giftEl = el;
    el.querySelector('[data-gift-close]').addEventListener('click', function () { el.hidden = true; });
    el.addEventListener('click', function (e) { if (e.target === el) el.hidden = true; });
    this.wireGiftImage(el);
    this.bindGiftForm(el);
  };

  /* banner image is the hero once it loads → hide the text fallback; if it
     fails to load (e.g. not uploaded yet), drop the image and keep the text */
  AiPathQuiz.prototype.wireGiftImage = function (el) {
    var img = el.querySelector('[data-gift-image-el]');
    if (!img) return;
    var text = el.querySelector('[data-gift-text]');
    img.addEventListener('load', function () { if (text) text.style.display = 'none'; });
    img.addEventListener('error', function () { img.style.display = 'none'; });
    if (img.complete && img.naturalWidth > 0 && text) text.style.display = 'none';
  };

  AiPathQuiz.prototype.bindGiftForm = function (el) {
    var self = this;
    var form = el.querySelector('[data-gift-form]');
    if (!form) return;
    var phone = el.querySelector('[data-gift-phone]');
    var consent = el.querySelector('[data-gift-consent]');
    var submit = el.querySelector('[data-gift-submit]');
    function refresh() {
      submit.disabled = !(consent.checked && phone.value.replace(/\s/g, '').length >= 7);
    }
    phone.addEventListener('input', refresh);
    consent.addEventListener('change', refresh);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit.disabled) return;
      self.answers.__phoneSent = true;
      self.answers.__phone = phone.value.trim();
      self.save();
      self.sendPhoneLead();
      /* swap the popup body to the download state — keep the popup open so
         they click the download right here — and update the report card too */
      el.querySelector('[data-gift-body]').innerHTML = self.giftPopupDoneHtml();
      self.refreshGiftCard();
    });
  };

  AiPathQuiz.prototype.refreshGiftCard = function () {
    var self = this;
    this.reportEl.querySelectorAll('.apq-leadcapture').forEach(function (s) { s.outerHTML = self.renderGiftCard(); });
    this.armGiftCard();
  };

  AiPathQuiz.prototype.openGiftPopup = function () {
    if (!this.giftEl) return;
    this.giftEl.hidden = false;
  };

  /* wires the "Claim it" reopen button + an auto-open once the visitor
     scrolls near the end of the report — same idea as the video gate,
     deferred until the video popup (if any) is resolved so they don't stack. */
  AiPathQuiz.prototype.armGiftCard = function () {
    var self = this;
    if (!this.giftActive()) return;
    if (!this.answers.__phoneSent && !this.giftEl) this.buildGiftPopup();
    this.reportEl.querySelectorAll('[data-gift-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openGiftPopup(); });
    });
    if (this.answers.__phoneSent) return;
    /* With a video gate, the gift opens RIGHT AFTER the video — triggered
       from the gate's dismiss handlers via openGiftAfterGate(), not on
       scroll. Only when there is NO video gate do we fall back to a
       scroll trigger (a couple screens into the report). */
    if (this.video.id) return;
    if (this._giftScroll) window.removeEventListener('scroll', this._giftScroll);
    var GIFT_SCROLL_SCREENS = 2;
    var firstCard = this.reportEl.querySelector('.apq-r-section, .apq-report-head');
    var fired = false;
    this._giftScroll = function () {
      if (fired || self.answers.__phoneSent) return;
      var vh = window.innerHeight;
      var firstCardBottom = firstCard ? (firstCard.getBoundingClientRect().bottom + window.scrollY) : vh;
      var scrolledPastFirst = (window.scrollY + vh) - firstCardBottom;
      var nearBottom = window.scrollY + vh > document.documentElement.scrollHeight - 200;
      if (scrolledPastFirst > vh * GIFT_SCROLL_SCREENS || nearBottom) {
        fired = true;
        window.removeEventListener('scroll', self._giftScroll);
        self.openGiftPopup();
      }
    };
    window.addEventListener('scroll', this._giftScroll, { passive: true });
  };

  /* called when the video popup is dismissed after they've unlocked it —
     shows the gift popup right after, once, with a short beat for a clean
     transition rather than an instant swap. */
  AiPathQuiz.prototype.openGiftAfterGate = function () {
    var self = this;
    if (!this.giftActive() || this.answers.__phoneSent || this._giftShown) return;
    this._giftShown = true;
    setTimeout(function () { self.openGiftPopup(); }, 500);
  };

  AiPathQuiz.prototype.sendPhoneLead = function () {
    this.postWebhook(this.buildLeadSnapshot('phone_captured'));
  };

  function parseYouTubeId(url) {
    if (!url) return '';
    var m = url.match(/(?:youtube\.com\/(?:watch\?[^#]*v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,20})/);
    return m ? m[1] : '';
  }

  /* ---------------- video gate (glassy popup after one scroll) ---------------- */

  AiPathQuiz.prototype.gateActive = function () {
    return !!this.video.id && !this.answers.__unlocked;
  };

  AiPathQuiz.prototype.buildGate = function () {
    var self = this;
    if (this.gateEl) this.gateEl.remove();
    var media = this.video.cover
      ? '<img src="' + esc(this.video.cover) + '" alt="">'
      : '<div class="apq-gate-media-fallback">&#8203;</div>';
    var el = document.createElement('div');
    el.className = 'apq-gate-backdrop';
    el.hidden = true;
    el.innerHTML =
      '<div class="apq-gate-card" role="dialog" aria-modal="true">' +
      '<button class="apq-gate-close" type="button" data-gate-close aria-label="Close">&times;</button>' +
      '<div class="apq-gate-media" data-gate-media>' + media +
      '<button class="apq-gate-play" type="button" data-gate-play aria-label="Play video">&#9654;</button>' +
      '</div>' +
      '<h3 class="apq-gate-heading">' + esc(this.video.heading) + '</h3>' +
      '<p class="apq-gate-text">' + esc(this.video.text) + '</p>' +
      '<button class="apq-btn apq-gate-continue" type="button" data-gate-continue hidden>Continue to your full path ↓</button>' +
      '</div>';
    this.root.appendChild(el);
    this.gateEl = el;
    /* hiding the popup does NOT stop a YouTube iframe — it keeps playing
       audio in the background. Blank the iframe src to actually stop it. */
    function hideGate() {
      var iframe = el.querySelector('[data-gate-media] iframe');
      if (iframe) iframe.src = 'about:blank';
      el.hidden = true;
    }
    el.querySelector('[data-gate-close]').addEventListener('click', function () { hideGate(); if (self.answers.__unlocked) self.openGiftAfterGate(); });
    el.addEventListener('click', function (e) { if (e.target === el) { hideGate(); if (self.answers.__unlocked) self.openGiftAfterGate(); } });
    el.querySelector('[data-gate-play]').addEventListener('click', function () {
      var box = el.querySelector('[data-gate-media]');
      box.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + self.video.id +
        '?autoplay=1&rel=0&modestbranding=1" title="Video" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      box.classList.add('is-playing');
      el.querySelector('[data-gate-continue]').hidden = false;
      self.unlock();
    });
    el.querySelector('[data-gate-continue]').addEventListener('click', function () {
      hideGate();
      var locked = self.reportEl.querySelector('[data-locked-start]');
      if (locked) locked.scrollIntoView({ behavior: 'smooth', block: 'start' });
      self.openGiftAfterGate();
    });
  };

  AiPathQuiz.prototype.openGate = function () {
    if (!this.gateEl || !this.gateActive()) return;
    this.gateEl.hidden = false;
  };

  AiPathQuiz.prototype.unlock = function () {
    this.answers.__unlocked = true;
    this.save();
    var wrap = this.reportEl.querySelector('[data-locked]');
    if (wrap) wrap.classList.add('is-unlocked');
    var overlay = this.reportEl.querySelector('[data-locked-overlay]');
    if (overlay) overlay.remove();
  };

  /* inline video, embedded in the "Free & solo" route card instead of a
     plain link out — pressing play also unlocks the gated content, same
     as watching the popup video, since either one proves engagement. */
  AiPathQuiz.prototype.bindInlineVideo = function () {
    var self = this;
    var box = this.reportEl.querySelector('[data-inline-video]');
    if (!box) return;
    var playBtn = box.querySelector('[data-inline-video-play]');
    if (!playBtn) return;
    playBtn.addEventListener('click', function () {
      box.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + self.video.id +
        '?autoplay=1&rel=0&modestbranding=1" title="Video" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      box.classList.add('is-playing');
      self.unlock();
    });
  };

  AiPathQuiz.prototype.armGate = function () {
    var self = this;
    if (!this.gateActive()) return;
    this.buildGate();
    var overlayBtn = this.reportEl.querySelector('[data-gate-open]');
    if (overlayBtn) overlayBtn.addEventListener('click', function () { self.openGate(); });
    if (this._gateScroll) window.removeEventListener('scroll', this._gateScroll);
    var fired = false;
    this._gateScroll = function () {
      if (fired || !self.gateActive()) return;
      if (window.scrollY > window.innerHeight * 0.8) {
        fired = true;
        window.removeEventListener('scroll', self._gateScroll);
        self.openGate();
      }
    };
    window.addEventListener('scroll', this._gateScroll, { passive: true });
  };

  /* Three routes, same destination — honest time-to-skill comparison.
     The free route is real (with a real link) but gets a real timeline. */
  AiPathQuiz.prototype.renderRoutes = function (res) {
    var prof = PROFILES[res.profile] || PROFILES.grinder;
    var freeSpan = res.pace === 'light' ? '12–18 months' : res.pace === 'intense' ? '6–10 months' : '8–14 months';
    var courseSpan = res.pace === 'light' ? '8–10 weeks' : res.pace === 'intense' ? '3–5 weeks' : '5–8 weeks';
    var hi = res.tier === 'allin' ? 'transfer' : res.tier === 'starter' ? 'free' : 'course';
    var mark = function (k) { return k === hi ? ' apq-r-route--hi' : ''; };

    var html = '<section class="apq-r-section apq-r-routes"><h3>Three routes. Same destination. Very different clocks.</h3>';
    html += '<p class="apq-r-note">All three are real. The only honest difference between them is time.</p>';
    html += '<div class="apq-r-route-grid">';

    html += '<div class="apq-r-route' + mark('free') + '">';
    html += '<h4>🧭 Free & solo</h4><p class="apq-r-route-time">' + freeSpan + '</p>';
    html += '<p>YouTube, docs, trial and error. It works — for the few who survive it. Most people quit around week 3, when the novelty dies and the results haven’t arrived yet.</p>';
    html += '<p class="apq-r-route-warn">' + prof.freeWarn + '</p>';
    if (this.video.id) {
      html += '<div class="apq-gate-media apq-inline-video" data-inline-video>' +
        (this.video.cover ? '<img src="' + esc(this.video.cover) + '" alt="">' : '<div class="apq-gate-media-fallback">&#8203;</div>') +
        '<button class="apq-gate-play" type="button" data-inline-video-play aria-label="Play video">&#9654;</button>' +
        '</div>';
    } else if (this.urls.youtube) {
      html += '<a class="apq-btn apq-btn--ghost" href="' + this.urls.youtube + '">▶ Start free on my channel</a>';
    }
    html += '</div>';

    html += '<div class="apq-r-route' + mark('course') + '">';
    html += '<h4>🎯 Structured</h4><p class="apq-r-route-time">' + courseSpan + '</p>';
    html += '<p>The courses: a fixed curriculum, the exact tools above, in the right order, with nothing to figure out alone. You trade a little money for most of a year.</p>';
    html += '</div>';

    html += '<div class="apq-r-route' + mark('transfer') + '">';
    html += '<h4>⚡ Skill transfer</h4><p class="apq-r-route-time">Days per skill</p>';
    html += '<p>Courses + coffee sessions. You don’t hunt the skill — it’s handed to you, on your own project, 1-on-1. The fastest version of this that exists.</p>';
    html += '</div>';

    html += '</div></section>';
    return html;
  };

  /* Tiered offer block — good / better / best ladder matched to willingness to invest.
     The recommended tier renders big; one line offers the step up or down. */
  AiPathQuiz.prototype.renderOffer = function (res, A, name) {
    var u = this.urls;
    var primaryCourse = (res.archetype === 'B' || res.archetype === 'O') ? 'infra' : 'content';
    var courseLabel = { content: '🎬 AI Content Creation course', infra: '⚙️ AI Infrastructure course' };
    var seatsLine = this.coffeeSeats
      ? '<p class="apq-r-seats">☕ Heads up: I personally run every coffee session — I keep only ' + esc(this.coffeeSeats) + ' seats open per month, first come first served.</p>'
      : '';

    var html = '<section class="apq-r-section apq-r-cta" style="--apq-accent:' + A.color + '">';
    html += '<h3>' + (name ? esc(name) + ', here' : 'Here') + '’s how we do this together</h3>';

    if (res.tier === 'starter') {
      html += '<p>You told us budget matters right now — so here’s the lean route. It costs almost nothing and still gets you moving this week:</p>';
      html += '<ol class="apq-r-offer">';
      if (u.youtube) html += '<li>Start free: my YouTube walkthroughs cover your first steps<br><a class="apq-btn apq-btn--ghost" href="' + u.youtube + '">▶ Watch free on YouTube</a></li>';
      if (u[primaryCourse]) html += '<li>When you’re ready for the full system, one course is all your path needs to begin:<br><a class="apq-btn" href="' + u[primaryCourse] + '">' + courseLabel[primaryCourse] + '</a></li>';
      if (u.coffee) html += '<li>And keep <strong>one coffee bean</strong> in your pocket — a single 1-on-1 session at the exact moment you get stuck is worth more than ten courses:<br><a class="apq-btn apq-btn--coffee" href="' + u.coffee + '">☕ 1 coffee bean · one session</a></li>';
      html += '</ol>';
      html += '<p class="apq-r-alt">Moving faster than expected? The full route (both courses + coaching pack) is always one click away.</p>';
    } else if (res.tier === 'allin') {
      html += '<p>Your answers say you’re not here to dabble — you want the whole thing: the skills, the systems, and speed. This is the route I built for exactly that:</p>';
      html += '<div class="apq-r-flagship">';
      html += '<p class="apq-r-flag-label">THE ALL-IN ROUTE</p>';
      html += '<p><strong>Work with me directly.</strong> A 5-bean coffee pack = five 1-on-1 sessions: we design your stack, build alongside you, and course-correct in real time — while both courses give you the full curriculum between sessions.</p>';
      if (u.coffee5) html += '<a class="apq-btn apq-btn--coffee" href="' + u.coffee5 + '">☕ 5-bean pack · work with me directly</a>';
      html += '<div class="apq-r-cta-grid">';
      if (u.content) html += '<a class="apq-btn apq-btn--ghost" href="' + u.content + '">' + courseLabel.content + '</a>';
      if (u.infra) html += '<a class="apq-btn apq-btn--ghost" href="' + u.infra + '">' + courseLabel.infra + '</a>';
      html += '</div></div>';
      html += seatsLine;
      html += '<p class="apq-r-alt">Prefer to start smaller? Begin with just the ' + (primaryCourse === 'infra' ? 'Infrastructure' : 'Content Creation') + ' course and add sessions later.</p>';
    } else {
      html += '<p>This analysis is yours to keep, free. When you’re ready to move, this is the core route your path above is built around:</p>';
      html += '<div class="apq-r-cta-grid">';
      if (u[primaryCourse]) html += '<a class="apq-btn" href="' + u[primaryCourse] + '">' + courseLabel[primaryCourse] + ' — start here</a>';
      var second = primaryCourse === 'content' ? 'infra' : 'content';
      if (u[second]) html += '<a class="apq-btn apq-btn--ghost" href="' + u[second] + '">' + courseLabel[second] + '</a>';
      if (u.coffee) html += '<a class="apq-btn apq-btn--coffee" href="' + u.coffee + '">☕ Coffee beans · 1-on-1 sessions at the hard parts</a>';
      html += '</div>';
      html += seatsLine;
      if (u.coffee5) html += '<p class="apq-r-alt">Want maximum speed? The <a href="' + u.coffee5 + '">5-bean pack</a> means I’m personally in your corner for the whole climb.</p>';
    }
    html += '</section>';
    return html;
  };

  /* expose for testing */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeResult: computeResult, QUESTIONS: QUESTIONS, ARCHETYPES: ARCHETYPES };
  }

  if (typeof window === 'undefined') return;

  if ('customElements' in window && !customElements.get('ai-path-quiz')) {
    customElements.define('ai-path-quiz', class extends HTMLElement {
      connectedCallback() { if (!this._apq) this._apq = new AiPathQuiz(this); }
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('ai-path-quiz'), function (el) {
        if (!el._apq) el._apq = new AiPathQuiz(el);
      });
    });
  }
})();
